import React from "react";
import styled from "styled-components";
import "./styles.scss";
import { mobile, mobileM } from "../../responsive";
import { motion, useViewportScroll, useTransform } from "framer-motion";

import imgInterior from "../../img/interior_design_img-9bexP0hs.jpg";

// const WrapperSectionImgOnScroll = styled.div`
//   background-color: pink;
//   min-height: 120vh;
//   position: relative;
// `;

const AnimaBanner = styled.div`
  width: 88%;
  height: 86vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  background-image: url(${imgInterior});
  background-position: right bottom 14%;
  background-size: cover;
  background-color: white;

  border-radius: 50px;

  ${mobile({
    height: "70vh",
    backgroundPosition: "center",
  })}
  ${mobileM({
    height: "70vh",
  })} //


  /*

  ------------

  animation-delay: -2s;
  animation: mymove 9s infinite alternate-reverse ease-in-out;
  background-repeat: no-repeat;



  position: relative;


bed
https://images.pexels.com/photos/6969784/pexels-photo-6969784.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940


https://images.unsplash.com/photo-1600585152915-d208bec867a1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=852&q=80
 @keyframes mymove {
    0% {
      background-image: url(https://images.pexels.com/photos/6538898/pexels-photo-6538898.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940);
    }
    25% {
      background-image: url(https://images.pexels.com/photos/6538903/pexels-photo-6538903.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940);
    }
    50% {
      background-image: url(https://images.pexels.com/photos/6538933/pexels-photo-6538933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940);
    }
    100% {
      background-image: url(https://images.pexels.com/photos/6538934/pexels-photo-6538934.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940);
    }
  } */

  //
`;

//
//

//
const TextWrapper = styled.div`
  /* this is an overlay, you can add text on this */
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;

  ${mobile({
    height: "70vh",
    justifyContent: "center",
  })}
  ${mobileM({
    height: "70vh",
    display: "flex",
    justifyContent: "center",
  })} //
`;

//
//
const CardText = styled.div`
  margin: 0 0 100px 0;
  button {
    font-weight: 600;
    font-size: calc(7px + 1vmin);

    background-color: transparent;
    border: 1.5px solid #f7f7f7;
    color: #f7f7f7;
    text-transform: uppercase;
    padding: 13px 35px;
    margin: 0 60px 0 35px;

    transition: 0.3s ease-in-out;
    &:hover {
      padding: 13px 35px;
      margin: 0 60px 0 35px;
      background-color: rgb(10, 10, 10);
      border: 1.5px solid rgb(24, 24, 24);
      font-weight: 100;
      color: #eeeeee;
    }
  }
`;
//
//

const AnimationBanner = () => {
  const { scrollYProgress } = useViewportScroll();
  //
  //
  const scale = useTransform(scrollYProgress, [1, 0], [0.2, 1.2]);

  //
  //
  return (
    <>
      <div id="section-ImgOnScroll">
        <div className="wrapper-imgscroll">
          <motion.div
            className="container-imgscroll"
            style={{
              scale,
            }}
          >
            <motion.img
              src={imgInterior}
              // className="item-imgscroll"
              style={{
                width: "100%",
                height: "100%",
                // scaleY: scrollYProgress,
                //
              }}
            />
          </motion.div>
        </div>
      </div>

      {/* <AnimaBanner>
        <div className="imgWrapper">
          <TextWrapper>
            <CardText>
              <button>More Details</button>
            </CardText>
          </TextWrapper>
        </div>
      </AnimaBanner> */}
    </>
  );
};

export default AnimationBanner;
